export default __webpack_public_path__ + "static/media/abdullahbabur.d9d315be.jpg";